import * as React from 'react';

function SvgPmsEmpty(props) {
  return (
    <svg width={320} height={270} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#fff" d="M0 0h320v270H0z" />
      <path
        d="M288.916 66.964H188.631a9.084 9.084 0 00-9.084 9.084v26.669a9.084 9.084 0 009.084 9.083h100.285a9.084 9.084 0 009.084-9.083v-26.67a9.084 9.084 0 00-9.084-9.083z"
        fill="#fff"
        stroke="#D9D9D9"
        strokeWidth={0.89}
      />
      <path
        d="M283.507 80.549h-67.42a2.689 2.689 0 000 5.377h67.42a2.688 2.688 0 100-5.377zM257.863 92.543h-41.776a2.689 2.689 0 000 5.377h41.776a2.688 2.688 0 100-5.377z"
        fill="#F5F5F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M197.993 100.926c-6.329 0-11.461-5.204-11.461-11.623s5.132-11.623 11.461-11.623c6.33 0 11.461 5.204 11.461 11.623s-5.131 11.623-11.461 11.623z"
        fill="#38B2A6"
      />
      <path
        d="M202.029 87.366l-4.842 5.165-2.907-3.098"
        stroke="#fff"
        strokeWidth={1.679}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M163.863 144.712v54.092a7.148 7.148 0 01-7.155 7.147H29.154A7.148 7.148 0 0122 198.804v-54.092a7.157 7.157 0 017.154-7.158h127.554a7.158 7.158 0 017.155 7.158z"
        fill="#fff"
        stroke="#D9D9D9"
        strokeWidth={0.89}
      />
      <path
        d="M70.984 200.897H33.41a5.166 5.166 0 01-5.159-5.162v-37.598a5.166 5.166 0 015.16-5.162h37.575a5.166 5.166 0 015.158 5.162v37.598a5.16 5.16 0 01-5.159 5.162z"
        fill="#38B2A6"
      />
      <path
        d="M163.863 144.712c-.001.476-.19.932-.526 1.269a1.8 1.8 0 01-1.27.526H23.795A1.798 1.798 0 0122 144.712a7.157 7.157 0 017.154-7.158h127.554a7.158 7.158 0 017.155 7.158z"
        fill="#fff"
        stroke="#D9D9D9"
        strokeWidth={0.89}
      />
      <path
        d="M31.216 142.206a1.448 1.448 0 01-1.447 1.447 1.447 1.447 0 01-.001-2.895c.801.01 1.448.655 1.448 1.448zm5.59 0a1.45 1.45 0 01-1.446 1.447 1.45 1.45 0 01-1.447-1.447 1.45 1.45 0 011.445-1.448c.801.01 1.448.655 1.448 1.448zm5.59 0a1.45 1.45 0 01-1.446 1.447 1.447 1.447 0 01-.002-2.895 1.45 1.45 0 011.448 1.448z"
        fill="#D9D9D9"
        stroke="#D9D9D9"
        strokeWidth={0.607}
      />
      <path
        d="M107.461 153.809H86.663a6.574 6.574 0 000 13.148h20.798a6.574 6.574 0 000-13.148zM107.461 186.32H86.663a6.574 6.574 0 100 13.148h20.798a6.574 6.574 0 000-13.148zM94.074 170.065h-7.41a6.574 6.574 0 100 13.148h7.41a6.575 6.575 0 000-13.148z"
        fill="#F5F5F5"
      />
      <path
        d="M121.564 170.065h-7.41a6.574 6.574 0 100 13.148h7.41a6.574 6.574 0 000-13.148z"
        fill="url(#pms-empty_svg__paint0_linear_11_789)"
      />
      <path
        d="M149.055 170.065h-7.41a6.574 6.574 0 100 13.148h7.41a6.574 6.574 0 000-13.148z"
        fill="url(#pms-empty_svg__paint1_linear_11_789)"
      />
      <path
        d="M149.055 153.809h-20.797a6.575 6.575 0 000 13.148h20.797a6.574 6.574 0 100-13.148z"
        fill="url(#pms-empty_svg__paint2_linear_11_789)"
      />
      <path
        d="M149.055 186.32h-20.797a6.574 6.574 0 000 13.148h20.797a6.574 6.574 0 100-13.148z"
        fill="url(#pms-empty_svg__paint3_linear_11_789)"
      />
      <path
        d="M44.051 182.246l-5.428-5.429 5.428-5.428m16.286 0l5.428 5.428-5.428 5.429M54.3 168.675l-4.525 16.285"
        stroke="#fff"
        strokeWidth={3.599}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M297.8 125.189v54.092a7.148 7.148 0 01-7.154 7.148H163.092a7.148 7.148 0 01-7.154-7.148v-54.092a7.158 7.158 0 017.154-7.159h127.554a7.158 7.158 0 017.154 7.159z"
        fill="#fff"
        stroke="#D9D9D9"
        strokeWidth={0.89}
      />
      <path
        d="M204.922 181.374h-37.575a5.166 5.166 0 01-5.159-5.162v-37.598a5.166 5.166 0 015.159-5.162h37.575a5.166 5.166 0 015.159 5.162v37.598a5.16 5.16 0 01-5.159 5.162z"
        fill="#F5F5F5"
      />
      <path
        d="M297.8 125.189a1.794 1.794 0 01-1.795 1.795H157.733a1.792 1.792 0 01-1.795-1.795 7.158 7.158 0 017.154-7.159h127.554a7.158 7.158 0 017.154 7.159z"
        fill="#fff"
        stroke="#D9D9D9"
        strokeWidth={0.89}
      />
      <path
        d="M165.154 122.683a1.452 1.452 0 01-1.447 1.447 1.452 1.452 0 01-1.446-1.447 1.45 1.45 0 011.444-1.448c.802.01 1.449.654 1.449 1.448zm5.59-.001a1.448 1.448 0 01-2.469 1.023 1.447 1.447 0 011.021-2.47 1.456 1.456 0 011.448 1.447zm5.59 0a1.451 1.451 0 01-1.447 1.448 1.452 1.452 0 01-1.446-1.448 1.449 1.449 0 011.445-1.447 1.45 1.45 0 011.448 1.447z"
        fill="#E1E4E5"
        stroke="#E1E4E5"
        strokeWidth={0.607}
      />
      <path
        d="M241.398 134.286h-20.797a6.574 6.574 0 100 13.148h20.797a6.574 6.574 0 100-13.148zM241.398 166.797h-20.797a6.574 6.574 0 100 13.148h20.797a6.574 6.574 0 100-13.148zM228.011 150.541h-7.41a6.574 6.574 0 000 13.148h7.41a6.574 6.574 0 100-13.148zM255.502 150.541h-7.41a6.574 6.574 0 000 13.148h7.41a6.574 6.574 0 100-13.148zM282.993 150.541h-7.411a6.575 6.575 0 000 13.148h7.411a6.574 6.574 0 000-13.148zM282.993 134.286h-20.797a6.574 6.574 0 100 13.148h20.797a6.574 6.574 0 100-13.148zM282.993 166.797h-20.797a6.574 6.574 0 100 13.148h20.797a6.574 6.574 0 100-13.148z"
        fill="#F5F5F5"
      />
      <path
        d="M177.989 162.722l-5.429-5.428 5.429-5.429m16.285 0l5.429 5.429-5.429 5.428m-6.036-13.57l-4.525 16.285"
        stroke="#fff"
        strokeWidth={3.599}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M173.397 65.712v54.091a7.148 7.148 0 01-7.154 7.148H38.688a7.148 7.148 0 01-7.153-7.148V65.712a7.157 7.157 0 017.153-7.16h127.555a7.157 7.157 0 017.154 7.16z"
        fill="#fff"
        stroke="#D9D9D9"
        strokeWidth={0.89}
      />
      <path
        d="M80.52 121.896H42.943a5.166 5.166 0 01-5.159-5.162V79.136a5.166 5.166 0 015.159-5.161h37.575a5.166 5.166 0 015.159 5.161v37.598a5.16 5.16 0 01-5.159 5.162z"
        fill="#38B2A6"
      />
      <path
        d="M173.397 65.712a1.793 1.793 0 01-1.795 1.794H33.329a1.795 1.795 0 01-1.794-1.794 7.157 7.157 0 017.153-7.16h127.555a7.157 7.157 0 017.154 7.16z"
        fill="#fff"
        stroke="#D9D9D9"
        strokeWidth={0.89}
      />
      <path
        d="M40.75 63.205a1.45 1.45 0 01-1.446 1.448 1.45 1.45 0 01-1.446-1.448 1.45 1.45 0 011.445-1.448c.8.01 1.448.655 1.448 1.448zm5.591 0a1.45 1.45 0 01-1.446 1.448 1.45 1.45 0 01-1.447-1.448 1.45 1.45 0 011.445-1.448c.801.01 1.448.655 1.448 1.448zm5.59 0a1.45 1.45 0 01-1.447 1.448 1.45 1.45 0 01-1.446-1.448 1.45 1.45 0 011.445-1.448 1.45 1.45 0 011.448 1.448z"
        fill="#D9D9D9"
        stroke="#D9D9D9"
        strokeWidth={0.607}
      />
      <path
        d="M116.995 74.808H96.198a6.574 6.574 0 000 13.148h20.797a6.574 6.574 0 100-13.148zM116.995 107.319H96.198a6.574 6.574 0 000 13.148h20.797a6.574 6.574 0 100-13.148zM103.608 91.064h-7.41a6.574 6.574 0 000 13.148h7.41a6.574 6.574 0 000-13.148zM131.099 91.064h-7.41a6.574 6.574 0 100 13.148h7.41a6.574 6.574 0 000-13.148z"
        fill="#F5F5F5"
      />
      <path
        d="M158.59 91.064h-7.41a6.574 6.574 0 100 13.148h7.41a6.574 6.574 0 000-13.148z"
        fill="url(#pms-empty_svg__paint4_linear_11_789)"
      />
      <path
        d="M158.59 74.808h-20.797a6.574 6.574 0 100 13.148h20.797a6.574 6.574 0 100-13.148zM158.59 107.319h-20.797a6.574 6.574 0 000 13.148h20.797a6.574 6.574 0 100-13.148z"
        fill="#F5F5F5"
      />
      <path
        d="M53.586 103.245l-5.428-5.428 5.428-5.429m16.285 0l5.429 5.429-5.429 5.428m-6.036-13.57l-4.524 16.284"
        stroke="#fff"
        strokeWidth={3.599}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M147.138 140.069l5.577-1.696 24.248-.714 5.469 1.493-.714 13.325-12.371 7.894-12-.24-7.544-6.874-1.675-6.816-.99-6.372z"
        fill="#F8AE9D"
      />
      <path
        d="M217.144 161.499c-1.755-3.619-3.437-6.524-4.937-8.818a21.973 21.973 0 00-12.655-9.211l-19.777-5.36s-1.027 19.763-14.629 19.763c-13.603 0-16.253-18.532-16.253-18.532l-22.887 9.131c-.786.306-6.095 2.141-12.269 15.387-5.884 12.611-8.455 19.07-8.455 19.07l23.579 6.809 1.47 21.204-.502 12.109 71.565-.16-.401-13.842.299-21.227.896 1.45 23.818-9.554s-3.066-6.291-8.862-18.219z"
        fill="#FCCE01"
      />
      <path
        d="M162.835 147.12c5.804-.107 12.398-11.429 12.398-11.429l.378-29.082c.303-8.376-4.907-15.513-14.298-15.553l-.872.04c-8.741.416-15.663 6.748-15.897 14.549-.221 7.261-.354 15.282-.069 19.157.593 8.022 9.745 6.668 9.745 6.668.019 0-.025 4.041 0 6.401.069 5.3 6.284 9.429 8.615 9.249z"
        fill="#F8AE9D"
      />
      <path
        d="M172.711 108.204c.16-.076 6.412-2.164 6.551 4.011.14 6.176-6.405 5.037-6.418 4.86-.013-.177-.133-8.871-.133-8.871zm-65.397 75.315l-9.59 19.246a14.034 14.034 0 00-1.456 6.939c.364 7.471 6.532 13.348 14.01 13.348l27.727-.436.977-13.705-20.927-5.047 7.929-14.993-18.67-5.352zm117.476-3.312s5.949 17.672 12.437 33.735c.131.321.277.918.394 1.246 1.463 3.983-2.942 7.864-7.391 7.864l-37.494-.066v-12.189l23.323-4.952-8.446-18.758 17.177-6.88z"
        fill="#F8AE9D"
      />
      <path
        d="M149.643 210.236c.007.044.859-.226 2.279-.313a12.041 12.041 0 015.41.917 12.01 12.01 0 014.405 3.27c.918 1.085 1.311 1.893 1.348 1.864.014-.007-.073-.211-.27-.561-.281-.492-.6-.962-.954-1.405a11.513 11.513 0 00-4.442-3.379c-2.038-.866-4.085-1.012-5.512-.866-.565.049-1.125.143-1.675.283-.385.095-.597.175-.589.19zm1.281-2.949c.015.058.881-.371 2.374-.415 1.486-.066 3.575.386 5.527 1.565 1.951 1.187 3.415 2.687 4.449 3.765.495.524.903.961 1.223 1.296.291.306.452.474.466.459.015-.008-.131-.197-.4-.517a43.907 43.907 0 00-1.165-1.347c-1.012-1.107-2.469-2.644-4.457-3.852-1.988-1.202-4.136-1.639-5.651-1.529a6.703 6.703 0 00-1.762.32c-.204.058-.349.131-.451.175-.102.044-.153.072-.153.08z"
        fill="#EB996E"
      />
      <path
        d="M200.622 208.561h-5.382s-12.145-4.391-14.643-3.969c-2.25.379-10.486 5.847-12.102 6.932a1.056 1.056 0 00-.393.495 1.763 1.763 0 00.983 2.243l.167.073-.073.248c-.096.318-.138.65-.124.983.059 1.158 1.617 1.507 2.207.51l-.313.553a1.37 1.37 0 00-.175.735l.029.503a1.354 1.354 0 001.694 1.233c.251-.066.477-.203.651-.396 1.041-1.15 3.298-3.451 4.828-3.706 1.354-.226 3.618-.255 4.988-.248.339.001.67.104.949.297.28.192.495.464.616.781-.903.066-7.216 3.357-9.452 4.536-.691.364-1.208 1.02-1.296 1.799-.08.699.27 1.435 1.653 1.107 2.971-.692 8.309-3.146 8.309-3.146s2.752-.786 4.536.473c2.512 1.77 3.663 2.418 5.818 1.705 2.156-.714 3.743-1.741 3.743-1.741l4.246-.422c.014 0 4.026-10.035-1.464-11.578z"
        fill="#F8AE9D"
      />
      <path
        d="M184.58 210.614c-.008.044-.859-.225-2.279-.313a12.053 12.053 0 00-5.41.918 12.005 12.005 0 00-4.406 3.269c-.918 1.085-1.311 1.893-1.347 1.864-.015-.007.073-.211.269-.561.281-.492.6-.962.954-1.405a11.53 11.53 0 014.442-3.378c2.039-.867 4.085-1.013 5.512-.867a10.46 10.46 0 011.675.284c.386.102.597.175.59.189zm-1.282-2.949c-.014.059-.881-.371-2.373-.415-1.486-.065-3.576.386-5.528 1.566-1.951 1.187-3.415 2.687-4.448 3.764-.496.525-.904.961-1.224 1.296-.291.307-.451.474-.466.459-.014-.007.131-.196.4-.517.27-.327.663-.786 1.166-1.347 1.012-1.107 2.468-2.643 4.456-3.852 1.988-1.201 4.136-1.638 5.651-1.529a6.745 6.745 0 011.762.32c.204.059.349.131.451.175a.54.54 0 01.153.08z"
        fill="#EB996E"
      />
      <path
        d="M193.34 223.394h-56.498a2.992 2.992 0 01-2.993-2.869l-1.697-38.885a3.002 3.002 0 012.993-3.131h59.783a3.007 3.007 0 013 3.124l-1.588 38.892a2.998 2.998 0 01-3 2.869z"
        fill="#253680"
      />
      <path
        d="M170.746 201.671a5.774 5.774 0 01-5.778 5.778 5.773 5.773 0 01-5.778-5.778 5.773 5.773 0 015.778-5.778 5.783 5.783 0 015.778 5.778z"
        fill="#fff"
      />
      <path d="M170.527 119.455h5.097V141.3h-5.097v-21.845z" fill="#F8AE9D" />
      <path
        d="M172.527 99.936c-.918 1.185-2.538 1.446-3.872 1.68-1.794.315-2.681.971-3.612 2.732-.59 1.125-1.18 2.357-2.235 2.967-.858.497-.826-.771-.962-1.754a2.27 2.27 0 00-.053-.258c-.208-.784-1.042-.65-1.287.123-.223.697-.701 1.286-1.31 1.614-.099.054-.205.1-.31.08-.143-.02-.254-.154-.347-.274a9.025 9.025 0 01-.59-.913c-.658-1.115-1.903-.716-2.638.35-.459.663-1.005 1.346-1.756 1.5-.242.054-.546.014-.658-.221-.143-.287.08-.575.043-.87-.031-.275-.149-.395-.279-.63-.511-.909-1.682-.942-2.401-.187a26.278 26.278 0 01-1.565 1.513c-.23.201-.565.402-.794.201-.124-.107-.155-.288-.18-.462-.131-.85-.255-1.701-.385-2.551-.074-.476-.329-1.098-.764-.978-.211.061-.335.282-.452.482-.143.255-2.694 3.154-2.744 2.933-.397-1.647-1.21-3.147-1.607-4.794-2.57-10.6 8.831-19.123 17.539-19.17 1.936-.014 3.705.018 5.586.466 2.005.483 4.121 1.248 5.939 2.326 2.551 1.507 4.481 4.245 3.985 7.513"
        fill="#252525"
      />
      <path
        d="M167.948 96.353c-1.281 1.406-1.62 3.386-1.74 5.255-.175 2.82.063 5.749 1.407 8.252.383.713.666 4.239 1.256 4.044.189-.06.157-2.795.654-4.269.766-2.284 4.296-3.154 5.884-1.711 2.538 2.296 1.049 5.085.208 6.821-.503 1.047-1.3 2.223-1.439 3.331-.169 1.419-.219 6.59.735 7.795.798 1.011 1.646-3.873 2.368-4.835 5.345-7.168 10.47-25.42 1.344-29.379-1.388-.603-5.671-.913-6.971-.146"
        fill="#252525"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208.963 52.192h-1.449a.633.633 0 01-.632-.633v-1.448c0-.35.285-.632.632-.632h1.449a.634.634 0 01.632.632v1.449a.63.63 0 01-.632.632zm-5.022 0h-1.449a.634.634 0 01-.632-.633v-1.448c0-.35.285-.632.632-.632h1.449a.634.634 0 01.632.632v1.449a.634.634 0 01-.632.632zm-5.025 0h-1.449a.632.632 0 01-.632-.633v-1.448c0-.35.285-.632.632-.632h1.449a.636.636 0 01.632.632v1.449a.63.63 0 01-.632.632zm-5.023 0h-1.448a.636.636 0 01-.632-.633v-1.448c0-.35.285-.632.632-.632h1.448c.35 0 .636.285.636.632v1.449a.64.64 0 01-.636.632zm-5.022 0h-1.448a.635.635 0 01-.635-.633v-1.448c0-.35.284-.632.635-.632h1.448a.636.636 0 01.633.632v1.449a.639.639 0 01-.633.632zm14.886-5.476h-1.449a.633.633 0 01-.632-.633v-1.451a.638.638 0 01.632-.632h1.449c.35 0 .632.285.632.632v1.449a.615.615 0 01-.184.449.634.634 0 01-.448.186zm-5.022 0h-1.449a.634.634 0 01-.632-.633v-1.451a.638.638 0 01.632-.632h1.449a.634.634 0 01.632.632v1.449a.636.636 0 01-.632.635zm-5.022 0h-1.449a.635.635 0 01-.635-.633v-1.451c0-.347.285-.632.635-.632h1.449a.634.634 0 01.632.632v1.449c0 .35-.285.635-.632.635zm5.203 11.359h-1.449a.632.632 0 01-.632-.633v-1.448c0-.35.285-.632.632-.632h1.449a.635.635 0 01.632.632v1.449a.63.63 0 01-.632.632zm-5.023 0h-1.448a.636.636 0 01-.632-.633v-1.448c0-.35.285-.632.632-.632h1.448c.35 0 .636.285.636.632v1.449a.64.64 0 01-.636.632z"
        fill="#D9D9D9"
      />
      <path
        d="M58.602 221.766H271.61a1.87 1.87 0 010 3.737H58.603a1.869 1.869 0 010-3.737zM250.219 213.938l10.876-10.875a.823.823 0 011.163 0h0a.823.823 0 010 1.163l-10.876 10.875a.821.821 0 01-1.162 0h-.001a.823.823 0 010-1.163zM256.894 213.986l3.136-3.137a.823.823 0 011.163 0h0a.82.82 0 010 1.163l-3.136 3.137a.823.823 0 01-1.163 0v-.001a.821.821 0 010-1.162z"
        fill="#D9D9D9"
        stroke="#D9D9D9"
        strokeWidth={0.383}
      />
      <defs>
        <linearGradient
          id="pms-empty_svg__paint0_linear_11_789"
          x1={118.298}
          y1={190.584}
          x2={118.038}
          y2={155.759}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset={1} stopColor="#EEE" />
        </linearGradient>
        <linearGradient
          id="pms-empty_svg__paint1_linear_11_789"
          x1={145.789}
          y1={190.584}
          x2={145.53}
          y2={155.759}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset={1} stopColor="#EEE" />
        </linearGradient>
        <linearGradient
          id="pms-empty_svg__paint2_linear_11_789"
          x1={139.381}
          y1={174.328}
          x2={139.224}
          y2={139.503}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset={1} stopColor="#EEE" />
        </linearGradient>
        <linearGradient
          id="pms-empty_svg__paint3_linear_11_789"
          x1={139.381}
          y1={206.839}
          x2={139.224}
          y2={172.013}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset={1} stopColor="#EEE" />
        </linearGradient>
        <linearGradient
          id="pms-empty_svg__paint4_linear_11_789"
          x1={155.323}
          y1={111.583}
          x2={155.064}
          y2={76.759}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset={1} stopColor="#EEE" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgPmsEmpty;
